import { useState, useCallback, useContext } from "react";
import uniq from "lodash/uniq";
import MessageFavoriteFieldsContext from "views/components/contexts/MessageFavoriteFieldsContext";
import useSendFavoriteFieldTelemetry from "views/components/messagelist/MessageFields/hooks/useSendFavoriteFieldTelemetry";
export const DEFAULT_FIELDS = ["source", "destination_ip", "usernames"];
const useMessageFavoriteFieldsForEditing = () => {
  const sendFavoriteFieldTelemetry = useSendFavoriteFieldTelemetry();
  const { saveFavoriteField, favoriteFields: initialFavoriteFields } = useContext(MessageFavoriteFieldsContext);
  const [favorites, setFavorites] = useState(initialFavoriteFields != null ? initialFavoriteFields : []);
  const resetFavoriteFields = useCallback(() => {
    setFavorites(DEFAULT_FIELDS);
    saveFavoriteField(DEFAULT_FIELDS);
  }, [saveFavoriteField]);
  const saveEditedFavoriteFields = useCallback(() => {
    saveFavoriteField(favorites);
  }, [favorites, saveFavoriteField]);
  const reorderFavoriteFields = useCallback(
    (items) => {
      sendFavoriteFieldTelemetry("REORDERED");
      setFavorites(items.map((item) => item.field));
    },
    [sendFavoriteFieldTelemetry]
  );
  const onFavoriteToggle = useCallback(
    (fieldName) => setFavorites((favs) => {
      const isFavorite = favs.includes(fieldName);
      if (isFavorite) return favs.filter((fav) => fav !== fieldName);
      return uniq([...favs, fieldName]);
    }),
    [setFavorites]
  );
  return {
    editingFavoriteFields: favorites,
    resetFavoriteFields,
    saveEditedFavoriteFields,
    reorderFavoriteFields,
    onFavoriteToggle
  };
};
export default useMessageFavoriteFieldsForEditing;
